import MollieBatchConfirmationRequest from 'src/adminPanel/entities/offsetting/mollieBatch/MollieBatchConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_MOLLIE_BATCHES = 'FETCH_MOLLIE_BATCHES';
export const REQUEST_MOLLIE_BATCHES = 'REQUEST_MOLLIE_BATCHES';
export const SUCCESS_MOLLIE_BATCHES = 'SUCCESS_MOLLIE_BATCHES';
export const FAILURE_MOLLIE_BATCHES = 'FAIL_MOLLIE_BATCHES';

export const FETCH_MOLLIE_SETTLEMENT_ORDERS = 'FETCH_MOLLIE_SETTLEMENT_ORDERS';
export const REQUEST_MOLLIE_SETTLEMENT_ORDERS = 'REQUEST_MOLLIE_SETTLEMENT_ORDERS';
export const SUCCESS_MOLLIE_SETTLEMENT_ORDERS = 'SUCCESS_MOLLIE_SETTLEMENT_ORDERS';
export const FAILURE_MOLLIE_SETTLEMENT_ORDERS = 'FAILURE_MOLLIE_SETTLEMENT_ORDERS';

export const fetchMollieSettlementOrders = (settlementId: string) =>
    action(FETCH_MOLLIE_SETTLEMENT_ORDERS, { settlementId });
export const requestMollieSettlementOrders = () => action(REQUEST_MOLLIE_SETTLEMENT_ORDERS);
export const requestMollieSettlementOrdersSuccess = (response: any) =>
    action(SUCCESS_MOLLIE_SETTLEMENT_ORDERS, { response });
export const requestMollieSettlementOrdersFailure = (error: any) => action(FAILURE_MOLLIE_SETTLEMENT_ORDERS, { error });

export const CONFIRM_MOLLIE_BATCH = 'CONFIRM_MOLLIE_BATCH';
export const REQUEST_CONFIRM_MOLLIE_BATCH = 'REQUEST_CONFIRM_MOLLIE_BATCH';
export const SUCCESS_CONFIRM_MOLLIE_BATCH = 'SUCCESS_CONFIRM_MOLLIE_BATCH';
export const FAILURE_CONFIRM_MOLLIE_BATCH = 'FAILURE_CONFIRM_MOLLIE_BATCH';

export const confirmMollieBatch = (id: string, mollieBatchConfirmationRequest: MollieBatchConfirmationRequest) =>
    action(CONFIRM_MOLLIE_BATCH, { id, mollieBatchConfirmationRequest });
export const requestConfirmMollieBatch = () => action(REQUEST_CONFIRM_MOLLIE_BATCH);
export const requestConfirmMollieBatchSuccess = (response: any) => action(SUCCESS_CONFIRM_MOLLIE_BATCH, { response });
export const requestConfirmMollieBatchFailure = (error: any) => action(FAILURE_CONFIRM_MOLLIE_BATCH, { error });

export const fetchMollieBatches = (
    pageable?: PageableQueryParams,
    settlementId?: string | undefined,
    confirmedState?: boolean | undefined
) => action(FETCH_MOLLIE_BATCHES, { pageable, settlementId, confirmedState });
export const requestMollieBatches = () => action(REQUEST_MOLLIE_BATCHES);
export const requestMollieBatchesSuccess = (response: any) => action(SUCCESS_MOLLIE_BATCHES, { response });
export const requestMollieBatchesFailure = (error: any) => action(FAILURE_MOLLIE_BATCHES, { error });
